<template>
  <div>

    <v-app-bar
      app
      color="primary"
      dark
      shrink-on-scroll
      prominent
      src="/kim_splash_web.jpg"
      fade-img-on-scroll
      scroll-threshold="150"
      :class='syncFromAppToCockpitAllowed ? "" : "cf-warn"'
      :data-warningOnRunState2="$t('Warnings.runState2')"
    >
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top right, rgba(212,8,44,.6), rgba(148,8,37,.6)"></v-img>
      </template>

      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title>
        <v-img
          alt="Vuetify Logo"
          class="shrink mt-2"
          contain
          src="/header_logo.png"
          transition="scale-transition"
          width="85"
        />
      </v-toolbar-title>

      <v-spacer></v-spacer>


      <v-btn text v-if="isLoading">
        <v-icon class="icon-spin">mdi-sync</v-icon> {{$i18n.t('SyncIndicator.active')}}
      </v-btn>

      <v-btn text v-if="false">
        <v-icon color="green">mdi-check</v-icon> {{$i18n.t('SyncIndicator.done')}}
      </v-btn>

      <v-btn text v-if="false">
        <v-icon color="orange lighten-3">mdi-alert</v-icon> {{$i18n.t('SyncIndicator.error')}}
      </v-btn>

      <!--
      <v-btn icon>
        <v-icon>mdi-heart</v-icon>
      </v-btn>

      <v-menu bottom left>
        <template v-slot:activator="{ on }">
          <v-btn icon color="yellow" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
      </v-menu>
      -->
      <template v-slot:extension>
        <v-tabs align-with-title v-model="activeTab">
          <v-tab v-for="tab in tabData" :key="tab.index" @click="navigate({ name: tab.route })"><v-icon v-if="tab.icon">{{tab.icon}}</v-icon><span v-if="tab.icon" class="d-none d-sm-flex">&nbsp;</span><span class="d-none d-sm-flex">{{$i18n.t(tab.title)}}</span></v-tab>
        </v-tabs>
      </template>
    </v-app-bar>

    <v-navigation-drawer app v-model="drawer" width="400">
      <v-list-item>
        <v-list-item-avatar>
          <v-icon class="grey lighten-1 white--text">mdi-account</v-icon>
          <!--<v-img
            src="https://www.ki-management.com/frontend/media/contacts/ratio_1/1551797304_KIM_Momme_Juergensen.jpg"
          ></v-img>-->
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{ getNameForPerson(currentObserver) }}</v-list-item-title>
        </v-list-item-content>
        <v-icon class="primary--text" @click="showConfirmLogout=true">mdi-logout</v-icon>
      </v-list-item>

      <v-list-item>
        <hub-status/>
        <v-list-item-content>&shy;
        </v-list-item-content>

        <v-btn icon class="mr-2" @click="collapseAll(false)">
          <v-icon color="lighten-1">mdi-collapse-all-outline</v-icon>
        </v-btn>
        <v-btn icon @click="collapseAll(true)">
          <v-icon color="lighten-1">mdi-expand-all-outline</v-icon>
        </v-btn>

      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <!--
      <v-list-item
        v-for="i in 4"
        :key="i"
        link
      >
        <v-list-item-icon>
          <v-icon color="orange lighten-1">mdi-circle</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>Kandidat {{ i+1 }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    -->
        <v-list-group no-action sub-group v-model="collapsedMenu[`participantGroup_${i}`]" v-for="(participant, i) in observerTimeTable" :key="participant.id" :ref="`participantGroup_${i}`">
          <template v-slot:activator>
            <v-list-item-avatar size="36" class="mr-2">
              <img v-if="participantImage(participant.id, participantImages)" :src="participantImage(participant.id, participantImages)">
              <v-icon v-else class="grey lighten-1 white--text">mdi-account</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ getNameForPerson(participant) }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-icon>
              <v-icon :color="businessLogic.getParticipantRatingStatus(participant, assessments, runInfo.competencyExerciseMatrix)">{{ businessLogic.getParticipantRatingIcon(participant, assessments, runInfo.competencyExerciseMatrix)}}</v-icon>
            </v-list-item-icon>
          </template>
          <template v-if='participant.participantDocuments && participant.participantDocuments[0]'>
            <v-list-item
              :class='{isHighlighted: participant.id === currentParticipantId && $route.name === "participantDocument"}'
              @click='setParticipant(participant.id)'
            >
              <v-list-item-title>{{ $t('Navigation.toParticipantDocument') }}</v-list-item-title>
            </v-list-item>
          </template>
          <template v-for="(schedule,i) in participant.exercises">
            <v-list-item
              :class="{isHighlighted: participant.id === currentParticipantId && schedule.exerciseId === currentExerciseId && !['participantDocument', 'overview'].includes($route.name)}"
              link :key="`ex_${participant.id}_${schedule.exerciseId}_${i}`"
              v-if="schedule && schedule.exercise"
              @click="setParticipantAndExercise(schedule.exerciseId,participant.id)">
              <v-list-item-title>{{schedule.exercise.name}}</v-list-item-title>
              <v-list-item-subtitle v-text="businessLogic.getRoomAndTime(schedule)"></v-list-item-subtitle>
              <v-list-item-icon>
                <v-icon :color="businessLogic.getExerciseRatingStatus(schedule, assessments, participant.id, runInfo.competencyExerciseMatrix)">{{ businessLogic.getExerciseRatingIcon(schedule, assessments, participant.id, runInfo.competencyExerciseMatrix)}}</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </template>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <!-- Modal -->
    <v-dialog class="logout-confirm-dialog" v-model="showConfirmLogout" width="400">
      <v-card>
        <v-card-title class="headline">{{$t('ConfirmLogoutDialog.title')}}</v-card-title>
        <v-card-text v-html="$t('ConfirmLogoutDialog.description')" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="showConfirmLogout=false">{{$t('ConfirmLogoutDialog.no')}}</v-btn>
          <v-btn color="primary" text @click="confirmedLogout()">{{$t('ConfirmLogoutDialog.yes')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import BusinessLogicOverview from '@/libs/businessLogicOverview';
import BusinessLogicAssessments from '@/libs/businessLogicAssessments';
import HubStatus from '@/libs/signalR/vue2Components/hubStatus.vue';
import { EventBus, EVENTS } from '../libs/eventBus';


export default {
  name: 'Navigation',
  components: { HubStatus },
  props: ['mobile'],
  data: () => ({
    drawer: null,
    showConfirmLogout: false,
    tabData: [
      {
        index: 0,
        route: 'overview',
        title: 'Navigation.menuItemOverview',
        icon: 'mdi-format-list-checks',
      },
      {
        index: 1,
        route: 'observation',
        title: 'Navigation.menuItemObservation',
        icon: 'mdi-clipboard-text-multiple-outline',
      },
      {
        index: 2,
        route: 'assessment',
        title: 'Navigation.menuItemAssessment',
        icon: 'mdi-clipboard-check-multiple-outline',
      },
      /*{
        index: 3,
        route: 'interview',
        title: 'Navigation.menuItemInterview',
        icon: 'mdi-account-voice'
      },*/
      {
        index: 4,
        route: 'manual',
        title: 'Navigation.menuItemManual',
        icon: 'mdi-book-open-page-variant',
      },
      {
        index: 5,
        route: 'mixed',
        title: 'Navigation.menuItemMixed',
        icon: 'mdi-clipboard-account-outline',
      },
    ],
    activeTab: 0,
    businessLogic: new BusinessLogicOverview(null),
    businessLogicAssessments: new BusinessLogicAssessments(null),
    collapsedMenu: {
      participantGroup_0: true,
    },
  }),
  computed: {
    ...mapGetters(['syncFromAppToCockpitAllowed', 'participantImages', 'currentObserver', 'assessments']),
    ...mapState(['runInfo', 'isLoading', 'observerTimeTable', 'currentExerciseId', 'currentParticipantId']),
  },
  methods: {
    setParticipantAndExercise(exerciseId, participantId) {
      this.businessLogic.setParticipantAndExercise(exerciseId, participantId);
      this.setActiveTabFromRoute();
      if (this.mobile) {
        this.drawer = false;
      }
    },
    setParticipant(participantId) {
      this.businessLogic.setParticipant(participantId);
      this.setActiveTabFromRoute();
    },
    getNameForPerson(person) {
      return `${person?.firstName} ${person?.lastName}`;
    },
    confirmedLogout() {
      // todo: Save data to server
      this.$store.commit('clearState');
      this.$hub.close();
      this.$router.push('/login');
    },
    setActiveTabFromRoute() {
      // console.log("current route", this.$route.name);
      // eslint-disable-next-line no-restricted-syntax
      for (const tab of this.tabData) {
        if (tab.route === this.$route.name || (this.$route.name === 'participantDocument' && tab.route === 'overview')) {
          this.activeTab = tab.index;
        }
      }
    },
    navigate(route) {
      if (route.name !== this.$route.name) {
        this.$router.push(route);
      }
    },
    collapseAll(value) {
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const ref in this.$refs) {
        console.log(ref);
        if (ref.includes('participantGroup_')) {
          console.log(this.$refs[ref][0]);
          this.collapsedMenu[ref] = value;
        }
      }
    },
    participantImage(participantId, images) {
      const imageList = images();
      if (imageList[participantId] === 404) return null;
      if (imageList[participantId]) {
        return imageList[participantId];
      }

      this.businessLogic.getParticipantImage(participantId);

      // update this component after 3 seconds to display participant photos
      const self = this;
      setTimeout(() => {
        self.$forceUpdate();
      }, 3000);

      return null;
    },
  },
  mounted() {
    this.setActiveTabFromRoute();
    const bl = new BusinessLogicOverview(this);
    this.businessLogic = bl;
    // this.businessLogic.loadRunInfo();
    // this.businessLogicAssessments = new BusinessLogicAssessments(this.$store, this.$apiRequest, this.$i18n);
    // this.businessLogicAssessments.loadAssessments();

    const self = this;
    EventBus.$on(EVENTS.ROUTE_PUSHED, () => {
      self.setActiveTabFromRoute();
    });
  },
};
</script>

<style scoped lang="scss">
  @import '@/ci.scss';

  .cf-warn::after{
    content: attr(data-warningOnRunState2);
    width: 100%;
    background-color: #ffa726;
    position: absolute;
    box-shadow: 0 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%);
    font-size: 1rem;
    color: #000;
    font-weight: bold;
    padding: .3rem 2rem;
  }

  .isHighlighted {
    background-color: $highlighted;
  }

  .icon-spin {
    -webkit-animation: spin 1500ms infinite linear;
    animation: spin 1500ms infinite linear;
  }
  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(-359deg);
      transform: rotate(-359deg);
    }
  }
  @keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(-359deg);
      transform: rotate(-359deg);
    }
  }

</style>
